(() => {
  const status = (message) => {
    const region = document.getElementById('a11y-status');
    if (region) region.textContent = message;
  };

  const preload = (source) => {
    if (!source) return;
    const image = new Image();
    image.src = source;
  };

  const replaceImage = (root, selector, source, alternativeText = '') => {
    if (!source) return;
    const image = root.querySelector(selector);
    if (!image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    if (alternativeText) image.alt = alternativeText;
  };

  const rememberCardVariant = (card, variantId) => {
    if (!card?.dataset.productId || !variantId) return;
    try {
      sessionStorage.setItem(`hlo-card-variant-${card.dataset.productId}`, variantId);
    } catch (error) {
      // Browsing still works when storage is unavailable.
    }
  };

  const previousCardVariant = (card) => {
    if (!card?.dataset.productId) return '';
    try {
      return sessionStorage.getItem(`hlo-card-variant-${card.dataset.productId}`) || '';
    } catch (error) {
      return '';
    }
  };

  const selectCardVariant = (button, announce = true) => {
    const card = button.closest('[data-product-card]');
    if (!card) return;
    card.querySelectorAll('[data-card-variant]').forEach((option) => {
      const selected = option === button;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', String(selected));
    });
    card.querySelectorAll('[data-card-link]').forEach((link) => { link.href = button.dataset.url; });
    const quickView = card.querySelector('[data-quick-view-url]');
    if (quickView) quickView.dataset.quickViewUrl = button.dataset.url;
    const label = card.querySelector('[data-card-selection]');
    if (label) label.textContent = button.dataset.label;
    const price = card.querySelector('[data-card-price]');
    if (price) price.textContent = button.dataset.price;
    const compare = card.querySelector('[data-card-compare]');
    if (compare) {
      compare.textContent = button.dataset.comparePrice || '';
      compare.hidden = !button.dataset.comparePrice;
    }
    replaceImage(card, '.product-card__media img', button.dataset.image, button.dataset.imageAlt);
    rememberCardVariant(card, button.dataset.variantId);
    if (announce) status(`${button.dataset.label} preview selected. Product image and price updated.`);
  };

  const normalizeOptionValue = (value) => (value || '').trim().toLocaleLowerCase();

  const initializeCardVariants = (root = document, rerun = false) => {
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      if (card.dataset.initialVariantApplied === 'true' && !rerun) return;

      const availableChoices = Array.from(card.querySelectorAll('[data-card-variant]')).filter((button) => (
        button.dataset.available === 'true' && Boolean(button.dataset.image)
      ));
      if (!availableChoices.length) return;

      const preferredValue = normalizeOptionValue(card.dataset.preferredVariant);
      let choice = null;

      if (preferredValue) {
        choice = availableChoices.find((button) => normalizeOptionValue(button.dataset.label) === preferredValue) || null;
      } else if (card.dataset.randomizeVariant === 'true') {
        const previousVariantId = previousCardVariant(card);
        const freshChoices = availableChoices.filter((button) => button.dataset.variantId !== previousVariantId);
        const choices = freshChoices.length ? freshChoices : availableChoices;
        choice = choices[Math.floor(Math.random() * choices.length)];
      }

      if (!choice) return;
      card.dataset.initialVariantApplied = 'true';
      selectCardVariant(choice, false);
    });
  };

  const selectQuickVariant = (button) => {
    const content = button.closest('[data-quick-view-content]');
    if (!content) return;
    const option = button.closest('.quick-option');
    option?.querySelectorAll('[data-quick-variant]').forEach((value) => {
      const selected = value === button;
      value.classList.toggle('is-selected', selected);
      value.setAttribute('aria-pressed', String(selected));
    });
    content.querySelectorAll('[data-quick-link]').forEach((link) => { link.href = button.dataset.url; });
    const label = option?.querySelector('[data-quick-selection]');
    if (label) label.textContent = button.dataset.label;
    const price = content.querySelector('[data-quick-price]');
    if (price) price.textContent = button.dataset.price;
    const compare = content.querySelector('[data-quick-compare]');
    if (compare) {
      compare.textContent = button.dataset.comparePrice || '';
      compare.hidden = !button.dataset.comparePrice;
    }
    const stock = content.querySelector('[data-quick-stock]');
    if (stock) {
      const available = button.dataset.available === 'true';
      stock.textContent = available ? 'Available' : 'Currently unavailable';
      stock.classList.toggle('stock-status--out', !available);
    }
    replaceImage(content, '.quick-view-content__media img', button.dataset.image);
    status(`${button.dataset.label} preview selected. Quick view updated.`);
  };

  document.addEventListener('click', (event) => {
    const railButton = event.target.closest('[data-rail-scroll]');
    if (railButton) {
      const rail = railButton.parentElement?.querySelector('[data-scroll-rail]');
      if (rail) rail.scrollBy({ left: Number(railButton.dataset.railScroll) * Math.max(140, rail.clientWidth * .72), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }
    const cardVariant = event.target.closest('[data-card-variant]');
    if (cardVariant) {
      selectCardVariant(cardVariant);
      return;
    }
    const quickVariant = event.target.closest('[data-quick-variant]');
    if (quickVariant) selectQuickVariant(quickVariant);
  });

  ['pointerover', 'focusin', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const variant = event.target.closest?.('[data-card-variant],[data-quick-variant]');
      if (variant?.dataset.image) preload(variant.dataset.image);
    }, { passive: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCardVariants());
  } else {
    initializeCardVariants();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) initializeCardVariants(document, true);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeCardVariants(event.target, true);
  });
})();
